import React from "react";
import PropTypes from "prop-types";
import { shortDateAndTimestamp } from "LIB/formatters/date";
import { Warning } from "MODULES/shared/components";
import { COMPANY_NAME, CONTACT_NAME, CREATED_AT } from "APP_ROOT/constants";

export default function ExistingQuoteWarning({ quote }) {
  return (
    <Warning>
      In the last 36 hours, this part number was quoted by{" "}
      {quote.get(CONTACT_NAME)} at {quote.get(COMPANY_NAME)} to{" "}
      {quote.getIn(["created_by", "full_name"])} at{" "}
      {shortDateAndTimestamp(quote.get(CREATED_AT))}. *Please proceed with
      caution.
    </Warning>
  );
}

ExistingQuoteWarning.propTypes = {
  quote: PropTypes.shape({
    company: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number
    })
  })
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/IncomingQuotes/Create/ExistingQuoteWarning.jsx